import React from 'react';
import {CloudIcon, HangerIcon, LockIcon, SparklesIcon} from '../icons';
import {PILLARS, PROBLEM} from './content';

const PILLAR_ICONS: Record<string, React.FC<{className?: string}>> = {
    inventory: HangerIcon,
    outfits: SparklesIcon,
    access: LockIcon,
    weather: CloudIcon,
};

/**
 * Секция «Возможности»: постановка проблемы и четыре опоры продукта.
 *
 * Намеренно без карточной обёртки: после плотного hero странице нужен воздух,
 * а не ещё одна белая коробка. Утверждение живёт прямо на фоне страницы,
 * опоры — разделённый колонками ряд под ним. Смена плотности и есть ритм.
 */
const FeatureColumns: React.FC = () => (
    <section id="features" className="scroll-mt-20 py-4 sm:py-8" aria-labelledby="landing-features-title">
        <h2
            id="landing-features-title"
            className="text-3xl sm:text-5xl font-bold leading-[1.04] tracking-[-0.03em] text-ink-900 dark:text-ink-50 max-w-[16ch] text-balance"
        >
            {PROBLEM.titleLead}
            <br className="hidden sm:block"/>
            {' '}{PROBLEM.titleSecond}{' '}
            <span className="text-brand-600 dark:text-brand-400">{PROBLEM.titleAccent}</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg leading-7 text-ink-600 dark:text-ink-300 max-w-[52ch]">{PROBLEM.lead}</p>

        <ul className="mt-12 grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-4
                       lg:divide-x lg:divide-ink-200 dark:lg:divide-white/10">
            {PILLARS.map((pillar, index) => {
                const Icon = PILLAR_ICONS[pillar.id];
                return (
                    <li key={pillar.id} className={`min-w-0 ${index > 0 ? 'lg:pl-8' : ''}`}>
                        <Icon className="w-6 h-6 text-brand-600 dark:text-brand-400"/>
                        <h3 className="mt-4 text-base font-semibold text-ink-900 dark:text-ink-50">{pillar.title}</h3>
                        <p className="mt-2 text-sm leading-6 text-ink-500 dark:text-ink-400">{pillar.text}</p>
                    </li>
                );
            })}
        </ul>
    </section>
);

export default FeatureColumns;
